const NON_US_COMMAND_PKG = {
    navTitle:"Non-US",
    routerName: "Non-USDocs",
    commandsDescription: "Canadian News, Tickers, etc...",

    commandList: [
        {
            title: "Canadian News",
            routerRef: "canews",
            commandString: "!canews <Symbol>",
            description: "Canada news source - newswire - 30 day history",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock for news" },
            ],
            examples: [
                "!canews GOOGL",
                "!canews AMD"
            ],
            type: "Non-US", 
            shortcuts: ["none"]
        },
        {
            title: "Canadian Tickers",
            routerRef: "tsx",
            commandString: "!tsx <Symbol>",
            description: "Canadian quotes for TSX",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!tsx GOOGL",
                "!tsx AMD"
            ],
            type: "Non-US", 
            shortcuts: ["none"]
        },
    ]
}



export {NON_US_COMMAND_PKG};